import React from "react"
import PageHeaderSection from "../../PagesContent/ChargingAnalytics/PageHeaderSection"
import { FullWidthSeparator } from "../../Components/CustomBox"
import KPISection from "../../PagesContent/AlertAnalytics/KPISection"
import ChartsSection from "../../PagesContent/AlertAnalytics/ChartsSection"
import { PageContainer, PageSectionContainer } from "../../PagesContent/AlertAnalytics/Components/StyledComponent"

function ChargingAnalyticsMain({ pagesContent }) {
  return (
    <PageContainer>
      <PageSectionContainer>
        <PageHeaderSection pagesContent={pagesContent}/>
        <KPISection pagesContent={pagesContent}/>
      </PageSectionContainer>
      <FullWidthSeparator/>
      <PageSectionContainer>
        <ChartsSection pagesContent={pagesContent}/>
      </PageSectionContainer>
    </PageContainer>
  )
}

export default ChargingAnalyticsMain
